module.exports = __webpack_public_path__ + "static/media/calibro-workspace.f4903470.png";